import { Box } from '@mui/material';
import React from 'react';
import { TDatabase } from '../../types/types';
import Field from './Field';
import { requiredFields } from './Data';
interface FieldsProps {
  info: any;
  viewMode: boolean;
  updateValues: (label: string, value: any, isFile?: boolean) => void;
}
const Fields = ({ info, viewMode, updateValues }: FieldsProps) => {
  if (!info || !info.vendor || info.vendor === 'webapi') return null;
  const fields = requiredFields[info.vendor as TDatabase];
  const getValue = (label: string) => {
    /**
     *
     * for keystore and truststore we are using the name of the file as the value
     * but we also have keystoreFileName and truststoreFileName in the info object
     * so based on future requirements we can use either of them
     * but for now we are using the name of the file as the value
     *
     */
    if (label === 'Connection Name') return info?.connectionName as string;
    if (label === 'Port') return info?.port as number;
    if (label === 'Key Store') return info.keystore?.name;
    if (label === 'Trust Store') return info.truststore?.name;
    if (label === 'Region') return info?.region as string;
    if (label === 'S3 Location') return info?.s3Location as string;
    if (label === 'HTTP Path') return info?.httpPath as string;
    if (label === 'Keystore Password') return info?.keystorePassword as string;
    if (label === 'Truststore Password') return info?.truststorePassword as string;
    if (['Token', 'Secret Key', 'Password'].includes(label)) {
      return viewMode ? (info?.password as string) : '';
    }

    if (['Username', 'Access Key'].includes(label)) return info?.username as string;
    if (['Server Hostname', 'Server', 'Host', 'Server Url'].includes(label))
      return info?.server as string;
    if (['Service Name', 'Database'].includes(label)) return info?.database as string;
    return '';
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      {fields.map((field, index) => {
        return (
          <Field
            key={`${info.vendor}-${field.label}-${index}`}
            type={field.type}
            label={field.label}
            vendor={info.vendor}
            value={getValue(field.label)}
            viewMode={viewMode}
            updateFunction={updateValues}
            rows={field.label === 'Token' && info.vendor === 'bigquery' ? 12 : undefined}
            multiline={field.label === 'Token'}
            placeHolder={
              field.label === 'Token' && info.vendor === 'bigquery'
                ? 'Copy, Paste the entire contents from the token json file including { }'
                : undefined
            }
          />
        );
      })}
    </Box>
  );
};

export default Fields;
